module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-10.94d5ed7e.jpg";